export default __webpack_public_path__ + "static/media/002-roast chicken.b37937e1.svg";